module.exports = "<div class=sub-group ng-if=filters[filterKey].length><div class=group_label><l10n>{{::label}}</l10n></div><div class=checkbox ng-repeat=\"option in filters[filterKey] | orderBy : 'Value'\"><checkbox class=styled_checkbox checklist-model=updateFilters[filterKey] checklist-value=option.Value></checkbox><span class=checkbox_label>{{option.Key}}</span></div></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/templates/filters-subgroup.html
// module id = 559
// module chunks = 0